import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

/**
 * POST /clients/:id/posts/generate-post
 * Payload: { startDate, publishingStyles, socialNetworkTypeIds, mediaAssetIds, eventId? }
 */
export const generatePostWithAI = createAsyncThunk(
  "generatePost/generateWithAI",
  async ({ clientId, payload }, { rejectWithValue }) => {
    try {
      const body = { ...(payload || {}) }
      delete body.endDate
      if (body.eventId == null || body.eventId === "" || Number(body.eventId) === 0) {
        delete body.eventId
      } else {
        body.eventId = Number(body.eventId)
      }
      const response = await post(`posts/clients/${clientId}/generate-post`, body)
      return response
    } catch (error) {
      return rejectWithValue(error.message || "Failed to generate post")
    }
  },
)

const generatePostSlice = createSlice({
  name: "generatePost",
  initialState: {
    generatedData: null,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    resetGeneratePost: (state) => {
      state.generatedData = null
      state.status = "idle"
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generatePostWithAI.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(generatePostWithAI.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.generatedData = action.payload
      })
      .addCase(generatePostWithAI.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { resetGeneratePost } = generatePostSlice.actions
export default generatePostSlice.reducer
